import { Link } from "react-router-dom";
import Seo from "@/components/Seo";

export default function NotFound() {
  return (
    <main className="mx-auto flex min-h-[60vh] max-w-2xl flex-col items-center justify-center px-4 py-16 text-center">
      <Seo title="Siden blev ikke fundet | SpørgMig" description="Siden findes ikke." path="/404" noIndex/>
      <p className="font-mono text-xs uppercase tracking-widest text-brand-fresh">404</p>
      <h1 className="mt-3 text-3xl font-semibold tracking-tight text-brand-ink">Siden blev ikke fundet</h1>
      <p className="mt-3 max-w-md text-sm leading-6 text-brand-body">Linket kan være gammelt eller adressen kan være skrevet forkert. Du kan gå tilbage til forsiden eller finde en ekspert.</p>
      <div className="mt-7 flex flex-wrap justify-center gap-3">
        <Link to="/" className="btn-primary">Gå til forsiden</Link>
        <Link to="/eksperter" className="inline-flex min-h-11 items-center rounded-lg border border-brand-line bg-white px-5 text-sm font-semibold text-brand-ink">Find en ekspert</Link>
      </div>
    </main>
  );
}

